import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const UnsupportedForm = ({ formTitle }) => {
  useEffect(() => {
    const lastCard = document.getElementById('unSupportedForm');
    if (window && lastCard && lastCard.offsetTop) {
      window.scrollTo({ top: lastCard.offsetTop - 100 });
    }
  }, []);

  return (
    <div id="unSupportedForm" className="question-card error unsupported-form">
      <p className="question-title"><strong>{`Form ${ formTitle || '' } Unsupported`}</strong></p>
      <p>Your required tax information cannot currently be accepted as it requires completing an unsupported tax form. Please speak to your designated contact.</p>
      <Link to="/form-selection" className="btn btn-link">Click here to view available forms.</Link>
    </div>);
};

UnsupportedForm.propTypes = {
  formTitle: PropTypes.string.isRequired
};

export default UnsupportedForm;
